/*=========================================================================================
    File Name:
    Description:
    ----------------------------------------------------------------------------------------
    Item Name: GetBoarded UI Template
    Author: GetBoarded
    Author URL: https://www.getboarded.com
==========================================================================================*/


export default {
  tasks: [],
  taskTags: [],
  todoSearchQuery: '',
  todoFilter: null,

  addSkillStep: 0,
  characteristic: '',
  competency: [],
  initialLevel: [],
  initialLevelText: '',
  trainingDuration: [],
  progressMeasure: [],
  reviewCompetency: []
}
